import { ContactModel } from './contactModel.model';
import { License } from './license.model';
import { QuestionModel } from './questionModel.model';


export class PublicAccountSubmission {
    Username: string;
    Password: string;
    ConfirmPassword: string; // TODO: Needed server-side?
    SecurityQuestion: string;
    SecurityAnswer: string;
    Email: string;
    PhoneNumber: string;
    PermissionToSendSMSMsgs: boolean;
    Contacts: ContactModel[] = new Array<ContactModel>();
    licenseLinks: License[] = new Array<License>();
    Questions: QuestionModel[] = new Array<QuestionModel>();
}
